export const useContactEmbed = defineStore('embed', {
    state: () => ({
        showEmbed: false
    }),
    actions: {
        setShowEmbed(value: boolean) {
            this.showEmbed = value;
        }
    }
});
